/* jshint esversion: 6 */
/* jshint ignore:start */

import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation();
    const content = (
        <div className="w-full h-[100vh] flex justify-center pt-40 relative z-[9999] bg-white">
            <div className="text-center">
                <h1 className="text-6xl font-bold">404</h1>
                <h2 className="text-2xl mt-4">{t("Page Not Found")}</h2>
                <h4 className="mt-6 text-lg">{t("Sorry, the page you are looking for does not exist.")}</h4>
            </div>
        </div>
    );
    const portalRoot = document.getElementById('portal-root');

    return portalRoot ? createPortal(content, portalRoot) : content;
};

export default NotFound;
/* jshint ignore:end */

